import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

// Neutral Latin-American Spanish. Keyed by the English source string so UI copy
// can be wrapped with t("English text") without inventing keys. Live restaurant
// data (Google Places) intentionally stays in its original language.
export const ES = {
  // Header / nav
  "Crawls": "Rutas",
  "Passports": "Pasaportes",
  "Trophies": "Trofeos",
  "Bingo": "Bingo",
  "Solo Fates": "Destinos solo",
  "Groups": "Grupos",
  "Your stash": "Tu alijo",
  "Theme": "Tema",
  "Reaper (Original)": "Segador (Original)",
  "Coffee Shop": "Cafetería",
  "Fall": "Otoño",
  "Winter": "Invierno",
  "Spring": "Primavera",
  "Summer": "Verano",
  "Cyberscape": "Cyberscape",
  "Steampunk": "Steampunk",
  "Tiki Lounge": "Salón Tiki",
  "Pick a theme": "Elige un tema",
  "Choose your realm": "Elige tu reino",
  "Every theme reshapes the ritual — scenery, sounds, and the voice of fate. Choose yours.": "Cada tema transforma el ritual: escenario, sonidos y la voz del destino. Elige el tuyo.",
  "Fairy Gully": "Cañada de Hadas",
  "Let Fate Decide": "Que el destino decida",
  "Tap the wand": "Toca la varita",
  "Rare fate": "Destino raro",
  "The fae hid your fate — scratch the ring": "Las hadas ocultaron tu destino: rasca el anillo",
  "Enter Fork·Fate": "Entrar a Fork·Fate",
  "You can change your realm anytime from the Theme menu.": "Puedes cambiar tu reino cuando quieras desde el menú Tema.",
  "Tap a realm to enter — the Theme pill up top brings you back anytime.": "Toca un reino para entrar — el botón Tema de arriba te trae de vuelta cuando quieras.",
  "Add": "Agregar",
  "Guided": "Guiado",
  "Sponsor your spot": "Promociona tu local",
  "Favorites": "Favoritos",
  "Download the app!": "¡Descarga la app!",
  "Add spot": "Agregar local",
  "Add a spot": "Agregar un local",
  "Contribute": "Contribuir",
  "Mute": "Silenciar",
  "Unmute": "Activar sonido",

  // Hero
  "Let fate decide.": "Deja que el destino decida.",
  "Spin the deck and let Fork·Fate deal you a real local restaurant, bar, or dessert spot near you.": "Gira el mazo y deja que Fork·Fate te reparta un restaurante, bar o postre local de verdad cerca de ti.",

  // Modes
  "Food": "Comida",
  "Drinks": "Bebidas",
  "Bars": "Bares",
  "Desserts": "Postres",
  "Shops": "Tiendas",
  "Fuel": "Combustible",
  "Fuel & Go": "Combustible y transporte",
  "Gas, EV & getting around": "Gasolina, eléctricos y transporte",
  "Sponsors": "Patrocinadores",
  "Now on Android!": "¡Ya en Android!",
  "Help us launch — join the beta test.": "Ayúdanos a lanzar: únete a la prueba beta.",
  "Join beta": "Unirse a la beta",
  "Coming to Android!": "¡Pronto en Android!",
  "Want early access? Join the beta.": "¿Quieres acceso anticipado? Únete a la beta.",
  "Your Gmail:": "Tu Gmail:",
  "Sending…": "Enviando…",
  "You're on the list! We'll add you to the Android beta shortly. 🎉": "¡Estás en la lista! Te añadiremos a la beta de Android pronto. 🎉",
  "Feature your business here": "Anuncia tu negocio aquí",
  "Antiques, thrift & more": "Antigüedades, segunda mano y más",
  "Gas & EV charging": "Gasolina y carga eléctrica",

  // Hero
  "Can't decide where to eat?": "¿No sabes dónde comer?",
  "Can't decide what to sip?": "¿No sabes qué tomar?",
  "Can't decide where to drink?": "¿No sabes dónde beber?",
  "Craving something sweet?": "¿Se te antoja algo dulce?",
  "Feeling like a treasure hunt?": "¿Con ganas de una búsqueda del tesoro?",
  "Need to fill up or charge?": "¿Necesitas cargar combustible o electricidad?",
  "Need to fill up or get moving?": "¿Necesitas combustible o transporte?",
  "Let fate pick tonight's table.": "Deja que el destino elija la mesa de hoy.",
  "Let fate pick your next sip.": "Deja que el destino elija tu próxima bebida.",
  "Let fate pick tonight's bar.": "Deja que el destino elija el bar de hoy.",
  "Let fate pick your sweet treat.": "Deja que el destino elija tu antojo dulce.",
  "Let fate pick your next find.": "Deja que el destino elija tu próximo hallazgo.",
  "Let fate pick your pit stop.": "Deja que el destino elija tu parada.",
  "Set the mood with a few filters and hit Deal. We'll shuffle great local restaurants — up to 50 miles out — and land on your next meal.": "Marca el ambiente con unos filtros y pulsa Repartir. Barajaremos grandes restaurantes locales —hasta 80 km a la redonda— y caeremos en tu próxima comida.",
  "Coffee, boba tea or a smoothie? Set your filters and hit Deal — we'll shuffle nearby drink spots and pick one for you.": "¿Café, boba o un smoothie? Ajusta tus filtros y pulsa Repartir: barajaremos lugares de bebidas cercanos y elegiremos uno para ti.",
  "Beer, whiskey, margaritas or a Tiki bar? Set your filters and hit Deal — we'll shuffle nearby bars and pick tonight's spot.": "¿Cerveza, whisky, margaritas o un bar Tiki? Ajusta tus filtros y pulsa Repartir: barajaremos bares cercanos y elegiremos el lugar de hoy.",
  "Ice cream, bakery, candy or froyo? Set your filters and hit Deal — we'll shuffle nearby dessert spots and pick your treat.": "¿Helado, panadería, dulces o yogur helado? Ajusta tus filtros y pulsa Repartir: barajaremos postres cercanos y elegiremos tu antojo.",
  "Antiques, thrift, vintage or a hobby shop? Set your filters and hit Deal — we'll shuffle nearby shops and pick your next find.": "¿Antigüedades, segunda mano, vintage o una tienda de pasatiempos? Ajusta tus filtros y pulsa Repartir: barajaremos tiendas cercanas y elegiremos tu próximo hallazgo.",
  "Set your filters and hit Deal — fate decides your next find.": "Ajusta tus filtros y pulsa Repartir: el destino decide tu próximo hallazgo.",

  // Controls
  "Your ZIP code": "Tu código postal",
  "(optional)": "(opcional)",
  "Locating…": "Ubicando…",
  "Search radius": "Radio de búsqueda",
  "Open now only": "Solo abiertos ahora",
  "Drink type": "Tipo de bebida",
  "Bar type": "Tipo de bar",
  "Dessert type": "Tipo de postre",
  "Shop type": "Tipo de tienda",
  "Fuel type": "Tipo de combustible",
  "Finding spots…": "Buscando lugares…",
  "Pick 3 Spots": "Elige 3 lugares",
  "Deal 3 Fates!": "¡Reparte 3 destinos!",
  "Shuffle the Deck": "Baraja el mazo",
  "Deal Your Fate!": "¡Reparte tu destino!",
  "spot nearby": "lugar cerca",
  "spots nearby": "lugares cerca",

  // Controls (existing)
  "ZIP code": "Código postal",
  "Group mode": "Modo grupo",
  "Pub Crawls & more": "Rutas de bares y más",
  "Pick your crawl": "Elige tu ruta",
  "Start / your area": "Inicio / tu zona",
  "2nd location set": "2.ª ubicación fijada",
  "End point": "Punto final",
  "(optional — crawl toward here)": "(opcional — dirígete hacia aquí)",
  "Use this location": "Usar esta ubicación",
  "clear": "borrar",
  "Plan a Crawl": "Planea una ruta",
  "Deal a Crawl!": "¡Reparte una ruta!",
  "fates dealt": "destinos repartidos",
  "crawls survived": "rutas superadas",
  "Nearby spots": "Lugares cercanos",
  "Featured": "Destacados",
  "Closest": "Más cercanos",
  "Use my location": "Usar mi ubicación",
  "Using your location": "Usando tu ubicación",
  "Cuisine": "Cocina",
  "All cuisines": "Todas las cocinas",
  "Open now": "Abierto ahora",
  "Within": "Dentro de",
  "miles": "millas",
  "Deal my fate": "Reparte mi destino",
  "Deal my fates": "Reparte mis destinos",
  "Shuffling…": "Barajando…",
  "Sort": "Ordenar",
  "Default": "Predeterminado",
  "Rating": "Calificación",
  "Price": "Precio",
  "Distance": "Distancia",

  // Reveal
  "Your table awaits": "Tu mesa te espera",
  "Set your filters and hit Deal — fate decides what you're sipping.": "Ajusta tus filtros y pulsa Repartir: el destino decide qué tomarás.",
  "Set your filters and hit Deal — fate decides where you're drinking.": "Ajusta tus filtros y pulsa Repartir: el destino decide dónde beberás.",
  "Set your filters and hit Deal — fate decides your sweet treat.": "Ajusta tus filtros y pulsa Repartir: el destino decide tu antojo dulce.",
  "Sponsored": "Patrocinado",
  "Closed right now — shuffle again for an open spot.": "Cerrado ahora mismo: baraja de nuevo para un lugar abierto.",
  "New": "Nuevo",
  "mi away": "mi de distancia",
  "Order on DoorDash": "Pedir en DoorDash",
  "Order online": "Pedir en línea",
  "Order / Delivery": "Pedir / Entrega",
  "Order treats": "Pedir postres",
  "Restaurant / order online": "Restaurante / pedir en línea",
  "Reviews & ratings": "Reseñas y calificaciones",
  "Shuffle again": "Barajar de nuevo",
  "Clear": "Limpiar",
  "Save to favorites": "Guardar en favoritos",
  "Copied to clipboard — share your fate!": "Copiado al portapapeles: ¡comparte tu destino!",
  "Fate card saved — share it anywhere!": "Tarjeta de destino guardada: ¡compártela donde quieras!",
  "Set your filters and hit Deal — fate decides where you're eating.": "Ajusta tus filtros y pulsa Repartir: el destino decide dónde comerás.",
  "Fate has spoken": "El destino ha hablado",
  "Re-roll": "Volver a tirar",
  "Reshuffle": "Barajar de nuevo",
  "Directions": "Cómo llegar",
  "Order delivery": "Pedir a domicilio",
  "Share your fate": "Comparte tu destino",
  "Share as image": "Compartir como imagen",
  "Add to favorites": "Agregar a favoritos",
  "Remove from favorites": "Quitar de favoritos",
  "Closed": "Cerrado",
  "Open": "Abierto",

  // How it works
  "How it works": "Cómo funciona",
  "Top rated": "Mejor valorados",
  "Cheapest": "Más baratos",
  "Let fate settle the \"where should we eat?\" debate.": "Deja que el destino resuelva el debate de \"¿dónde comemos?\".",
  "Fork·Fate is a restaurant roulette for anyone who's ever stared blankly at a food app, unable to decide. Set a couple of filters, shuffle the deck, and land on a real local place to eat, drink, or grab dessert — no endless scrolling, no group-chat deadlock.": "Fork·Fate es una ruleta de restaurantes para quien alguna vez se quedó mirando una app de comida sin poder decidir. Ajusta un par de filtros, baraja el mazo y cae en un lugar local de verdad para comer, beber o disfrutar un postre: sin scroll infinito ni discusiones en el chat grupal.",
  "1. Pick your craving": "1. Elige tu antojo",
  "Choose Food, Drinks, Bars, or Desserts, then narrow it down with cuisine chips and toggles like \"Open now\" and \"Gluten free\" to match the mood.": "Elige Comida, Bebidas, Bares o Postres, y luego afina con etiquetas de cocina y opciones como \"Abierto ahora\" y \"Sin gluten\" según tu ánimo.",
  "2. Set your location": "2. Fija tu ubicación",
  "Enter a ZIP code or tap \"Use my location\" and Fork·Fate pulls real, nearby restaurants within 50 miles using live Google data.": "Ingresa un código postal o toca \"Usar mi ubicación\" y Fork·Fate trae restaurantes reales y cercanos hasta 80 km usando datos en vivo de Google.",
  "3. Deal your fate": "3. Reparte tu destino",
  "Hit the button and watch the deck shuffle to reveal tonight's pick — with directions, reviews, delivery links, and a few more spots to consider if you want a re-roll.": "Pulsa el botón y mira cómo se baraja el mazo para revelar la elección de hoy: con indicaciones, reseñas, enlaces de entrega y algunos lugares más por si quieres volver a tirar.",
  "How does Fork·Fate pick a restaurant?": "¿Cómo elige Fork·Fate un restaurante?",
  "After you set your filters, Fork·Fate gathers matching local spots and randomly deals one from the deck. Every deal is a fresh shuffle, so you'll discover places you might never have chosen yourself.": "Después de ajustar tus filtros, Fork·Fate reúne los lugares locales que coinciden y reparte uno al azar del mazo. Cada reparto es una nueva baraja, así descubrirás lugares que quizá nunca habrías elegido.",
  "Is Fork·Fate free to use?": "¿Fork·Fate es gratis?",
  "Yes — Fork·Fate is completely free. There's no account, no signup, and no paywall. Just open it, shuffle, and go eat.": "Sí, Fork·Fate es totalmente gratis. Sin cuenta, sin registro y sin muros de pago. Solo ábrelo, baraja y ve a comer.",
  "Do I need to create an account?": "¿Necesito crear una cuenta?",
  "No login required. You can start spinning the moment the page loads, on your phone or desktop.": "No se requiere inicio de sesión. Puedes empezar a girar apenas cargue la página, en tu teléfono o computadora.",
  "How do you find nearby places?": "¿Cómo encuentran lugares cercanos?",
  "Fork·Fate uses live Google Places data based on your ZIP code or device location, so results reflect real, currently-listed restaurants, bars, and dessert shops around you.": "Fork·Fate usa datos en vivo de Google Places según tu código postal o la ubicación de tu dispositivo, así los resultados reflejan restaurantes, bares y postrerías reales listados actualmente cerca de ti.",
  "Can I add my favorite local spot?": "¿Puedo agregar mi lugar local favorito?",
  "Absolutely. Tap \"Add spot\" to submit a place you love. Community submissions are quickly reviewed before they join the roulette pool.": "Claro. Toca \"Agregar local\" para enviar un lugar que ames. Los envíos de la comunidad se revisan rápidamente antes de unirse a la ruleta.",
  "Can I install Fork·Fate as an app?": "¿Puedo instalar Fork·Fate como app?",
  "Yes — tap \"Download app\" to install Fork·Fate as a PWA on your home screen for one-tap access whenever hunger strikes.": "Sí, toca \"Descargar app\" para instalar Fork·Fate como PWA en tu pantalla de inicio y acceder con un toque cuando te dé hambre.",
  "A word from management:": "Un mensaje de la gerencia:",
  "A word from the Reaper:": "Un mensaje de la Parca:",
  "This page offers suggestions only and is not liable for any trouble you encounter in or with an establishment. Our algorithm merely queries the choices — the decision to visit any suggested establishment is yours alone.": "Esta página solo ofrece sugerencias y no se responsabiliza por ningún problema que encuentres en o con un establecimiento. Nuestro algoritmo solo consulta las opciones; la decisión de visitar cualquier establecimiento sugerido es solo tuya.",
  "— The Fork·Fate team": "— El equipo de Fork·Fate",
  "— The Reaper ☠️": "— La Parca ☠️",
  "Fork·Fate — let fate decide. All rights reserved.": "Fork·Fate — deja que el destino decida. Todos los derechos reservados.",
  "Frequently asked questions": "Preguntas frecuentes",

  // Footer / misc
  "Fates dealt": "Destinos repartidos",
  "day streak": "días seguidos",
  "Cancel": "Cancelar",
  "Close": "Cerrar",
  "Submit": "Enviar",
  "Loading…": "Cargando…",

  // Favorites drawer
  "Saved spots": "Lugares guardados",
  "Spots you've hearted, saved on this device.": "Lugares que marcaste, guardados en este dispositivo.",
  "No favorites yet": "Aún no hay favoritos",
  "Tap the heart on any spot to save it here for next time.": "Toca el corazón en cualquier lugar para guardarlo aquí para la próxima.",
  "Deal 3 from favorites": "Reparte 3 de favoritos",
  "Deal from my favorites": "Reparte de mis favoritos",

  // Install app
  "Open your browser menu and choose \u201CInstall app\u201D / \u201CAdd to Home Screen.\u201D": "Abre el menú de tu navegador y elige \u201CInstalar app\u201D / \u201CAgregar a la pantalla de inicio.\u201D",
  "Add to your iPhone": "Agrega a tu iPhone",
  "Apple installs web apps from Safari's Share menu — it only takes a few taps.": "Apple instala apps web desde el menú Compartir de Safari: solo toma unos toques.",
  "Got it": "Entendido",
  "Share": "Compartir",

  // Guided intro wizard
  "Restaurants & eats": "Restaurantes y comidas",
  "Coffee, boba, more": "Café, boba y más",
  "Cocktails & nightlife": "Cócteles y vida nocturna",
  "Something sweet": "Algo dulce",
  "Back": "Atrás",
  "Skip intro": "Saltar intro",
  "Step one": "Paso uno",
  "What calls to you?": "¿Qué se te antoja?",
  "Choose your craving to begin the ritual.": "Elige tu antojo para comenzar el ritual.",
  "Step two": "Paso dos",
  "Where shall fate look?": "¿Dónde buscará el destino?",
  "Enter ZIP": "Ingresa el código postal",
  "Location set": "Ubicación fijada",
  "Continue": "Continuar",
  "Step three": "Paso tres",
  "Narrow the fates": "Acota los destinos",
  "Pick any that tempt you — or let fate surprise you.": "Elige los que te tienten, o deja que el destino te sorprenda.",
  "Show less": "Ver menos",
  "more": "más",
  "Surprise me": "Sorpréndeme",
  "The final step": "El paso final",
  "The reaper offers your fate": "La Parca te ofrece tu destino",
  "Seal your": "Sella tu",
  "fate": "destino",
  "Fate Sealed": "Destino sellado",
  "The deck decides…": "El mazo decide…",
  "Once chosen, your fate is sealed.": "Una vez elegido, tu destino queda sellado.",
  "Location isn't supported on this device": "La ubicación no es compatible con este dispositivo",
  "Couldn't get your location — enter a ZIP instead": "No se pudo obtener tu ubicación: ingresa un código postal",

  // Sponsor dialog
  "Become a sponsor": "Conviértete en patrocinador",
  "Own a spot like this?": "¿Tienes un lugar como este?",
  "Get featured on every matching shuffle — first month free.": "Aparece en cada baraja que coincida: primer mes gratis.",
  "Sponsor your spot on Fork·Fate": "Promociona tu local en Fork·Fate",
  "Get pinned to the top of every matching shuffle with a Sponsored badge.": "Fíjate en la cima de cada baraja que coincida con una insignia de Patrocinado.",
  "month": "mes",
  "First month FREE · cancel anytime": "Primer mes GRATIS · cancela cuando quieras",
  "Monthly": "Mensual",
  "Yearly": "Anual",
  "mo": "mes",
  "yr": "año",
  "First month FREE": "Primer mes GRATIS",
  "2 months free": "2 meses gratis",
  "Save $38/yr": "Ahorra $38/año",
  "Billed $190 today, then annually · cancel anytime": "Se cobran $190 hoy, luego cada año · cancela cuando quieras",
  "Free first month, then $19/month · cancel anytime": "Primer mes gratis, luego $19/mes · cancela cuando quieras",
  "Loving fate's picks? Add Fork·Fate to your home screen.": "¿Te gustan las elecciones del destino? Añade Fork·Fate a tu pantalla de inicio.",
  "Install": "Instalar",
  "Add Fork·Fate to your home screen": "Añade Fork·Fate a tu pantalla de inicio",
  "Faster access, full-screen, works offline-ready.": "Acceso más rápido, pantalla completa y listo para usar.",
  "Tap the Share button in Safari": "Toca el botón Compartir en Safari",
  "Choose \u201CAdd to Home Screen\u201D": "Elige \u201CAñadir a pantalla de inicio\u201D",
  "Open this page in Safari, then tap Share \u2192 Add to Home Screen.": "Abre esta página en Safari y toca Compartir \u2192 Añadir a pantalla de inicio.",
  "Tap the \u22EE menu in your browser": "Toca el menú \u22EE de tu navegador",
  "Choose \u201CAdd to Home screen\u201D": "Elige \u201CAñadir a pantalla de inicio\u201D",
  "Maybe later": "Quizás más tarde",
  "Dismiss": "Cerrar",
  "Business photo": "Foto del negocio",
  "(optional, recommended)": "(opcional, recomendado)",
  "Upload photo": "Subir foto",
  "Replace photo": "Reemplazar foto",
  "Remove photo": "Quitar foto",
  "Uploading…": "Subiendo…",
  "Photo uploaded": "Foto subida",
  "Upload failed, please try again": "Error al subir, inténtalo de nuevo",
  "Please upload a JPG, PNG or WEBP image": "Sube una imagen JPG, PNG o WEBP",
  "Image too large (max 5 MB)": "Imagen demasiado grande (máx. 5 MB)",
  "…or paste an image URL": "…o pega la URL de una imagen",
  "No photo? We'll show a tasteful image matched to your cuisine.": "¿Sin foto? Mostraremos una imagen acorde a tu tipo de cocina.",
  "For local businesses": "Para negocios locales",
  "Own the top spot when fate is decided": "Sé el primero cuando el destino decide",
  "Sponsored spots appear first when locals shuffle for a place to eat, drink or treat themselves. Fixed monthly price, no bidding, cancel anytime.": "Los patrocinados aparecen primero cuando la gente busca dónde comer, beber o darse un gusto. Precio mensual fijo, sin pujas, cancela cuando quieras.",
  "or": "o",
  "Feature your business": "Destaca tu negocio",
  "More": "Más",
  "Less": "Menos",
  "Business name *": "Nombre del negocio *",
  "Category": "Categoría",
  "Cuisine / type *": "Cocina / tipo *",
  "Address": "Dirección",
  "Website / Instagram": "Sitio web / Instagram",
  "Image URL": "URL de imagen",
  "Contact email *": "Correo de contacto *",
  "Redirecting to PayPal…": "Redirigiendo a PayPal…",
  "Subscribe with PayPal": "Suscribirse con PayPal",
  "Secure checkout on PayPal. Your spot goes live automatically once your subscription is confirmed.": "Pago seguro en PayPal. Tu local se activa automáticamente en cuanto se confirme tu suscripción.",
  "Prefer to talk first?": "¿Prefieres hablar primero?",
  "Email us": "Escríbenos",
  "Business name, cuisine/type and email are required": "El nombre del negocio, la cocina/tipo y el correo son obligatorios",
  "Could not start checkout": "No se pudo iniciar el pago",

  // Add restaurant dialog
  "Add a restaurant": "Agregar un restaurante",
  "Suggest a local spot. New submissions are quickly reviewed before joining the roulette pool.": "Sugiere un lugar local. Los nuevos envíos se revisan rápidamente antes de unirse a la ruleta.",
  "Name": "Nombre",
  "Select": "Seleccionar",
  "Budget": "Económico",
  "Mid": "Medio",
  "Fancy": "Elegante",
  "Distance (km)": "Distancia (km)",
  "Description": "Descripción",
  "What makes it special?": "¿Qué lo hace especial?",
  "Submitting…": "Enviando…",
  "Submit for review": "Enviar para revisión",
  "Name and cuisine are required": "El nombre y la cocina son obligatorios",
  "Thanks! Your spot was submitted for review and will appear once approved.": "¡Gracias! Tu lugar se envió para revisión y aparecerá una vez aprobado.",
  "Could not add restaurant": "No se pudo agregar el restaurante",

  // Pub crawl dialog
  "Pub Crawl": "Ruta de bares",
  "Food Crawl": "Ruta de comida",
  "Drinks Crawl": "Ruta de bebidas",
  "Dessert Crawl": "Ruta de postres",
  "with": "con",
  "Your": "Tu",
  "Group": "Grupo",
  "stop": "parada",
  "stops": "paradas",
  "in a followable route — hit them in order, check each off, and claim your badge.": "en una ruta para seguir: visítalas en orden, marca cada una y reclama tu insignia.",
  "conquered": "conquistadas",
  "Auto check-in": "Registro automático",
  "Auto check-in ON": "Registro automático ACTIVADO",
  "Couldn't access location for auto check-in": "No se pudo acceder a la ubicación para el registro automático",
  "Arrived at": "Llegaste a",
  "Crawl conquered! ☠️ Claim your badge.": "¡Ruta conquistada! ☠️ Reclama tu insignia.",
  "Map": "Mapa",
  "Walk to next": "Camina al siguiente",
  "No stops selected — shuffle a fresh crawl below.": "No hay paradas seleccionadas: baraja una nueva ruta abajo.",
  "Who's with you? (e.g. Sam, Alex)": "¿Quién te acompaña? (ej. Sam, Alex)",
  "New crawl": "Nueva ruta",
  "Creating link…": "Creando enlace…",
  "Share with group": "Compartir con el grupo",
  "Crawl conquered — claim your badge": "Ruta conquistada: reclama tu insignia",
  "Check off all stops to unlock": "Marca todas las paradas para desbloquear",
  "Mark visited": "Marcar como visitada",
  "Mark not visited": "Marcar como no visitada",
  "Remove stop": "Quitar parada",
  "Join my": "Únete a mi",
  "Same crawl on your phone:": "La misma ruta en tu teléfono:",
  "Crawl link copied — drop it in the group chat!": "Enlace de ruta copiado: ¡compártelo en el chat del grupo!",
  "Couldn't create a share link — try again": "No se pudo crear el enlace: inténtalo de nuevo",

  // Crawl badge dialog
  "Please choose an image": "Elige una imagen",
  "Badge saved!": "¡Insignia guardada!",
  "Couldn't build the badge — try again": "No se pudo crear la insignia: inténtalo de nuevo",
  "Story image saved — post it to your IG Story!": "Imagen de historia guardada: ¡publícala en tu historia de IG!",
  "Crawl Complete": "Ruta completada",
  "Your reward awaits — claim your badge and share it.": "Tu recompensa te espera: reclama tu insignia y compártela.",
  "Congratulations": "¡Felicitaciones!",
  "You completed the": "Completaste la",
  "Take a selfie and claim your reward?": "¿Te tomas una selfie y reclamas tu recompensa?",
  "crawls completed on Fork·Fate": "rutas completadas en Fork·Fate",
  "Take a selfie & reveal my reward": "Tómate una selfie y revela mi recompensa",
  "Just show my reward": "Solo muéstrame mi recompensa",
  "Your photo stays on your device — it's added to the badge here on your phone and never uploaded or stored.": "Tu foto se queda en tu dispositivo: se agrega a la insignia aquí en tu teléfono y nunca se sube ni se guarda.",
  "Use a horizontal (landscape) photo so it fills the card frame.": "Usa una foto horizontal (apaisada) para que llene el marco de la tarjeta.",
  "Retake / change": "Volver a tomar / cambiar",
  "Add selfie": "Agregar selfie",
  "Remove": "Quitar",
  "Your name": "Tu nombre",
  "Share to your Story": "Compartir en tu historia",
  "Share badge": "Compartir insignia",
  "Download": "Descargar",

  // Shop / merch store
  "Back to app": "Volver a la app",
  "Dropping soon": "Muy pronto",
  "Wear your fate.": "Viste tu destino.",
  "Let Fate Decide.": "Deja que el destino decida.",
  "The FF crest on the chest, your favorite Fork·Fate world on the back. Premium print-on-demand tees, hoodies, mugs, posters & stickers — ": "El emblema FF en el pecho y tu mundo favorito de Fork·Fate en la espalda. Camisetas, sudaderas, tazas, pósters y pegatinas premium por encargo: ",
  "Tee": "Camiseta",
  "Hoodie": "Sudadera",
  "Mug": "Taza",
  "Poster": "Póster",
  "Sticker": "Pegatina",
  "from": "desde",
  "Front": "Frente",
  "left chest": "pecho izq.",
  "Sizes": "Tallas",
  "Scene": "Escena",
  "Crypt": "Cripta",
  "Classic": "Clásico",
  "Notify me when it drops": "Avísame cuando salga",
  "Printed on demand & shipped worldwide. Full checkout is coming to": "Impreso por encargo y enviado a todo el mundo. La tienda completa llegará a",
  "— join a design's list and we'll email you the moment it goes live.": "— únete a la lista de un diseño y te avisaremos en cuanto salga.",
  "Get first dibs": "Resérvala primero",
  "We'll email you the moment this design drops.": "Te avisaremos en cuanto salga este diseño.",
  "Notify me": "Avísame",
  "Adding you…": "Agregándote…",
  "No spam — just the drop. One email, then you're free.": "Sin spam, solo el lanzamiento. Un correo y listo.",
  "Please enter a valid email": "Introduce un correo válido",
  "You're on the list! We'll email you when it drops.": "¡Estás en la lista! Te avisaremos cuando salga.",
  "Something went wrong — please try again.": "Algo salió mal, inténtalo de nuevo.",
  "Shop the {theme} tee": "Compra la camiseta {theme}",
  "Shop Fork·Fate merch": "Compra la mercancía de Fork·Fate",
  "The red dragon brooding over its glittering hoard.": "El dragón rojo custodia su reluciente tesoro.",
  "The Reaper serving fate in his moonlit graveyard.": "La Parca sirve el destino en su cementerio a la luz de la luna.",
  "The gothic Reaper crest — bold and iconic.": "El emblema gótico de la Parca: audaz e icónico.",
  "A rain-slicked neon skyline that never sleeps.": "Un horizonte de neón bajo la lluvia que nunca duerme.",
  "A fierce dragon over gold — big-print statement.": "Un dragón feroz sobre el oro: estampado imponente.",
  "Warm torchlit tiki bar, straight off the island.": "Cálido bar tiki iluminado por antorchas, directo de la isla.",
  "Neon fork + skyline synthwave graphic.": "Tenedor de neón + horizonte estilo synthwave.",
  "Carved tiki mask + palms — tropical bold.": "Máscara tiki tallada + palmeras: tropical y audaz.",
  "Local spot": "Negocio local",
  "Chain coupon": "Cupón de cadena",
  "Pinned in matching shuffles": "Fijado en las barajas que coincidan",
  "Your coupon on every matching reveal": "Tu cupón en cada revelación que coincida",
  "See how chain coupons work": "Mira cómo funcionan los cupones de cadena",
  "Chains & franchises: coupon sponsorships": "Cadenas y franquicias: patrocinios con cupón",
  "first month FREE": "primer mes GRATIS",
  "Sponsor FAQ": "FAQ de patrocinio",
  "Sponsorship FAQ": "Preguntas frecuentes de patrocinio",
  "Everything about featuring your business on Fork·Fate.": "Todo sobre destacar tu negocio en Fork·Fate.",
  "More questions?": "¿Más preguntas?",
  "Your chain's coupon here": "El cupón de tu cadena aquí",
  "What does a local sponsorship include?": "¿Qué incluye un patrocinio local?",
  "Your business gets pinned to the top of every matching shuffle with a Sponsored badge, your photo and a link — $19/month (first month free) or $190/year.": "Tu negocio se fija en la parte superior de cada baraja que coincida con una insignia de Patrocinado, tu foto y un enlace — $19/mes (primer mes gratis) o $190/año.",
  "Your business gets pinned to the top of every matching shuffle with a Sponsored badge, your photo and a link — $19/month (first month free) or $190/year. Founder perk: add your own coupon offer at no extra cost.": "Tu negocio se fija en la parte superior de cada baraja que coincida con una insignia de Patrocinado, tu foto y un enlace — $19/mes (primer mes gratis) o $190/año. Ventaja de fundador: agrega tu propio cupón sin costo extra.",
  "How does the free local coupon work?": "¿Cómo funciona el cupón local gratis?",
  "While we're in our founder period, local sponsors can attach a coupon for free. It shows tap-to-reveal on your card when you win a spin, and also rides beside other matching reveals as a bonus offer.": "Durante nuestro periodo de fundadores, los patrocinadores locales pueden agregar un cupón gratis. Se muestra con toque-para-revelar en tu tarjeta cuando ganas un giro, y también acompaña otras revelaciones que coincidan como oferta extra.",
  "Add a coupon offer": "Agrega una oferta de cupón",
  "FREE — founder perk": "GRATIS — ventaja de fundador",
  "Optional: your deal shows on your winning card and rides beside matching reveals nearby — included free while we're in our founder period.": "Opcional: tu oferta se muestra en tu tarjeta ganadora y acompaña revelaciones cercanas que coincidan — incluido gratis durante nuestro periodo de fundadores.",
  "Coupon code": "Código de cupón",
  "Offer description": "Descripción de la oferta",
  "Add a short offer description for your coupon": "Agrega una breve descripción de la oferta de tu cupón",
  "+ FREE coupon": "+ cupón GRATIS",
  "Includes your coupon on winning reveals — FREE founder perk": "Incluye tu cupón en las revelaciones ganadoras — ventaja de fundador GRATIS",
  "For chains & franchises": "Para cadenas y franquicias",
  "Your coupon, on every plate fate deals": "Tu cupón, en cada plato que reparte el destino",
  "Chains never take a slot in the local deck. Instead, your offer gets a dedicated coupon strip beside the winner on every matching spin — national reach at the moment of decision.": "Las cadenas nunca ocupan un lugar en la baraja local. En cambio, tu oferta tiene una franja de cupón dedicada junto al ganador en cada giro que coincida — alcance nacional en el momento de decisión.",
  "Put your coupon in play": "Pon tu cupón en juego",
  "JACK IN": "CONÉCTATE",
  "Jack in": "Conéctate",
  "> intrusion detected — a fate is encrypted here": "> intrusión detectada — un destino está cifrado aquí",
  "> breaching fate.net ...": "> vulnerando fate.net ...",
  "> access granted": "> acceso concedido",
  "> decrypting target ...": "> descifrando objetivo ...",
  "> target acquired": "> objetivo adquirido",
  "Access code": "Código de acceso",
  "Enter the code to decrypt": "Ingresa el código para descifrar",
  "Access granted": "Acceso concedido",
  "Access denied": "Acceso denegado",
  "System override — fate decrypted": "Anulación del sistema — destino descifrado",
  "Pressure": "Presión",
  "Crank the gear": "Gira la manivela",
  "Crank the gear to vent the fate": "Gira la manivela para liberar el destino",
  "Pressure released!": "¡Presión liberada!",
  "Tap to shake the mug!": "¡Toca para agitar la copa!",
  "Tap to shake the globe!": "¡Toca para agitar el globo!",
  "Stir the cream away…": "Remueve la crema…",
  "Your fate, freshly brewed!": "¡Tu destino, recién hecho!",
  "Stir the latte": "Remueve el latte",
  "Snow Globe": "Globo de Nieve",
  "Latte Stir": "Latte Removido",
  "Shake the globe into a blizzard — the fate settles with the snow.": "Agita el globo hasta crear una ventisca: el destino se asienta con la nieve.",
  "The crest is drawn in the cream — stir it away and your fate is served.": "El emblema está dibujado en la crema: remuévelo y tu destino será servido.",
  "Shake the tiki mug": "Agita la copa tiki",
  "Shake the snow globe": "Agita el globo de nieve",
  "The fate settles in the snow!": "¡El destino se asienta en la nieve!",
  "7-day streak! Fate favors the faithful.": "¡Racha de 7 días! El destino favorece a los fieles.",
  "30-day streak! A month of fates — legendary.": "¡Racha de 30 días! Un mes de destinos: legendario.",
  "A grace day saved your streak — fate is merciful.": "Un día de gracia salvó tu racha: el destino es misericordioso.",
  "Heist witnessed!": "¡Atraco presenciado!",
  "Replay": "Repetir",
  "Realm Heists": "Atracos de los Reinos",
  "Sometimes the realm itself steals the house medallion. Keep your eyes on the logo.": "A veces el propio reino roba el medallón de la casa. No pierdas de vista el logo.",
  "Linger in a realm — its thief strikes when you least expect it.": "Quédate en un reino: su ladrón ataca cuando menos lo esperas.",
  "Saucer Abduction": "Abducción del Platillo",
  "Dragon Heist": "Atraco del Dragón",
  "Grave Snatch": "Zarpazo de la Tumba",
  "A stealth saucer locks its tractor beam on the medallion and beams it up — then drops it back.": "Un platillo sigiloso fija su rayo tractor en el medallón y lo eleva… luego lo devuelve.",
  "A scaled claw rises from the hoard and drags the medallion down into the gold.": "Una garra escamosa surge del tesoro y arrastra el medallón hacia el oro.",
  "Skeletal hands reach up from the grave and pull the medallion under.": "Manos esqueléticas emergen de la tumba y arrastran el medallón bajo tierra.",
  "Pixie Poof": "¡Puf del Hada!",
  "The tiny third sister flits up and — one wave of her wand — poofs the medallion into sparkles, then giggles it back.": "La diminuta tercera hermana sube volando y —con un toque de su varita— convierte el medallón en chispas, y luego lo devuelve entre risitas.",
  "Dragon's Breath": "Aliento de Dragón",
  "The tiny dragon huffs, puffs, and torches the medallion to cinders — don't worry, it always grows back.": "El pequeño dragón resopla y reduce el medallón a cenizas — tranquilo, siempre vuelve a crecer.",
  "The Awakening": "El Despertar",
  "The sleeping sentinel on the right stirs — head rising, eyes burning green — takes one thundering step forward, retreats, and powers back down to sleep.": "El centinela dormido de la derecha se agita: alza la cabeza, sus ojos arden en verde, da un paso atronador, retrocede y vuelve a apagarse.",
  "Furnace Blast": "Explosión del Horno",
  "The left sentinel's inner gears grind, his belly grate surges white-hot — then a roaring stream of fire, sparks and embers spews across the workshop.": "Los engranajes del centinela izquierdo rechinan, su rejilla ventral se enciende al rojo vivo… y una rugiente corriente de fuego, chispas y ascuas barre el taller.",
  "The Apprentice": "El Aprendiz",
  "Realm Seals": "Sellos de Reino",
  "While the sentinels perform, the half-built robot strapped to the assembly rack stirs — his head straightens and both lenses ignite solid green, watching.": "Mientras los centinelas actúan, el robot a medio construir atado al bastidor se agita: endereza la cabeza y ambas lentes se encienden en verde fijo, observando.",
  "Your stops": "Tus paradas",
  "Stops": "Paradas",
  "Numbered pins follow your route — green means conquered.": "Los pines numerados siguen tu ruta: el verde significa conquistado.",
  "Start here": "Empieza aquí",
  "Next": "Siguiente",
  "Fate of the Day": "Destino del Día",
  "Deal me this": "Reparte este",
  "Fate Journal": "Diario del Destino",
  "Every table fate has dealt you — and how it went.": "Cada mesa que el destino te ha repartido, y cómo fue.",
  "Chose well": "Eligió bien",
  "Dares taken": "Retos aceptados",
  "Top cuisine": "Cocina favorita",
  "You told fate it chose well": "Le dijiste al destino que eligió bien el",
  "of the time. The Reaper remembers.": "de las veces. La Parca lo recuerda.",
  "No fates yet.": "Aún no hay destinos.",
  "Deal your first card and your story begins here.": "Reparte tu primera carta y tu historia empieza aquí.",
  "Dish Dare": "Reto del Plato",
  "Fate picked the place — let it pick how you order": "El destino eligió el lugar: deja que elija cómo pides",
  "Order the spiciest thing on the menu.": "Pide lo más picante del menú.",
  "Let the server pick your meal.": "Deja que el camarero elija tu comida.",
  "Order the house special — no questions asked.": "Pide el especial de la casa, sin preguntas.",
  "Pick the dish you can't pronounce.": "Elige el plato que no puedas pronunciar.",
  "Order the cheapest thing… twice.": "Pide lo más barato… dos veces.",
  "Dessert first. Then decide the rest.": "El postre primero. Luego decide el resto.",
  "Order the first thing your eyes land on.": "Pide lo primero que veas.",
  "Copy whatever the next table ordered.": "Copia lo que pidió la mesa de al lado.",
  "Ask the kitchen to surprise you.": "Pide a la cocina que te sorprenda.",
  "Order something you've never tried before.": "Pide algo que nunca hayas probado.",
  "Get the weirdest-sounding appetizer.": "Pide el aperitivo con el nombre más raro.",
  "Go vegetarian tonight — fate says so.": "Hoy vegetariano: lo dice el destino.",
  "Close your eyes and point at the menu.": "Cierra los ojos y señala el menú.",
  "Order the last item on the menu.": "Pide el último plato del menú.",
  "Add the hottest sauce they have to whatever arrives.": "Añade su salsa más picante a lo que llegue.",
  "Split the decision: everyone orders for the person on their left.": "Divide la decisión: cada uno pide por la persona a su izquierda.",
  "Cuisine Bingo": "Bingo de Cocinas",
  "Squares stamp themselves when fate deals that cuisine.": "Las casillas se sellan solas cuando el destino reparte esa cocina.",
  "Complete a row, column or diagonal to earn a Collection stamp.": "Completa una fila, columna o diagonal para ganar un sello de la Colección.",
  "Stamps": "Sellos",
  "Free": "Libre",
  "Eat your way across the card — fate fills it in.": "Come por toda la carta: el destino la rellena.",
  "Card conquered — deal a fresh card": "Carta conquistada: reparte una nueva",
  "Cards conquered": "Cartas conquistadas",
  "cards conquered": "cartas conquistadas",
  "stamps earned": "sellos ganados",
  "BINGO! Line complete — stamp earned.": "¡BINGO! Línea completa: sello ganado.",
  "View card": "Ver carta",
  "Bingo square stamped:": "Casilla de bingo sellada:",
  "Share my card": "Compartir mi carta",
  "Share my story": "Compartir mi historia",
  "Building…": "Creando…",
  "Bingo card saved!": "¡Carta de bingo guardada!",
  "Story card saved!": "¡Tarjeta de historia guardada!",
  "Couldn't build the share image": "No se pudo crear la imagen",
  "Crew": "Equipo",
  "crew pins live — blue dots are your people.": "pines del equipo en vivo: los puntos azules son tu gente.",
  "crew pin live — blue dots are your people.": "pin del equipo en vivo: los puntos azules son tu gente.",
  "The fate pours out!": "¡El destino se derrama!",
  "Tap to wake the volcano!": "¡Toca para despertar el volcán!",
  "Wake the volcano": "Despierta el volcán",
  "Eruption! Fate emerges!": "¡Erupción! ¡El destino emerge!",
  "Draw a card": "Saca una carta",
  "Draw a card — the Reaper insists": "Saca una carta — el Segador insiste",
  "The Reaper turns your card...": "El Segador voltea tu carta...",
  "The Feast. Your table is set.": "El Festín. Tu mesa está servida.",
  "Knock on the coffin": "Toca el ataúd",
  "Knock three times...": "Toca tres veces...",
  "The Reaper answers...": "El Segador responde...",
  "Snuff the candle": "Apaga la vela",
  "Snuff the candles, one by one...": "Apaga las velas, una por una...",
  "The dark grows hungry...": "La oscuridad tiene hambre...",
  "The spirits have chosen...": "Los espíritus han elegido...",
  "What is the chain coupon tier?": "¿Qué es el nivel de cupón de cadena?",
  "Built for national and regional chains: your coupon appears in a dedicated strip beside the winning spot on every matching spin — you never take a slot in the local deck. $99/month or $990/year.": "Pensado para cadenas nacionales y regionales: tu cupón aparece en una franja dedicada junto al ganador en cada giro que coincida — nunca ocupas un lugar en la baraja local. $99/mes o $990/año.",
  "How does billing work?": "¿Cómo funciona la facturación?",
  "Secure PayPal subscription — your spot goes live automatically once payment is confirmed, and you can cancel anytime from PayPal.": "Suscripción segura con PayPal: tu negocio se publica automáticamente al confirmarse el pago y puedes cancelar cuando quieras desde PayPal.",
  "Can I update my listing or coupon later?": "¿Puedo actualizar mi anuncio o cupón después?",
  "Yes — email us and we'll update your photo, offer or details, usually within a day.": "Sí — escríbenos y actualizaremos tu foto, oferta o datos, normalmente en un día.",
  "Where will my business appear?": "¿Dónde aparecerá mi negocio?",
  "Local sponsors appear in their category's shuffle near their location. Chain coupons ride along on matching reveals everywhere Fork·Fate spins.": "Los patrocinadores locales aparecen en la baraja de su categoría cerca de su ubicación. Los cupones de cadena acompañan las revelaciones que coincidan dondequiera que gire Fork·Fate.",
  "YES": "SÍ",
  "NO": "NO",
  "GOOD BYE": "ADIÓS",
  "Touch the board — the spirits will spell it out": "Toca el tablero — los espíritus lo deletrearán",
  "The dragon sleeps... tap to wake it": "El dragón duerme... toca para despertarlo",
  "The dragon SEES your fate...": "El dragón VE tu destino...",
  "Break the lock!": "¡Rompe el candado!",
  "The hoard yields your fate!": "¡El tesoro entrega tu destino!",
  "Fates Witnessed": "Destinos Presenciados",
  "Back to the table": "Volver a la mesa",
  "Rare rituals your table has survived. Roughly one deal in ten turns rare.": "Rituales raros que tu mesa ha sobrevivido. Aproximadamente una tirada de cada diez resulta rara.",
  "witnessed": "presenciados",
  "Keep dealing — this fate hasn't shown itself yet.": "Sigue repartiendo — este destino aún no se ha mostrado.",
  "Exclusive rituals only appear in their home realm. Switch realms to hunt them all.": "Los rituales exclusivos solo aparecen en su reino. Cambia de reino para cazarlos todos.",
  "All realms": "Todos los reinos",
  "Reaper": "Segador",
  "Dragon's Hoard": "Tesoro del Dragón",
  "Scratch Foil": "Rasca y Gana",
  "Magic 8-Ball": "Bola 8 Mágica",
  "Wheel of Fate": "Rueda del Destino",
  "Fairy Wand": "Varita de Hada",
  "Hack Terminal": "Terminal Hacker",
  "Code Breaker": "Descifrador",
  "Crank Gear": "Manivela",
  "Tiki Shaker": "Coctelera Tiki",
  "Volcano Wake": "Despertar del Volcán",
  "Tarot Draw": "Tirada de Tarot",
  "Coffin Knock": "Llamada al Ataúd",
  "Séance Candles": "Velas de Sesión",
  "Ouija Board": "Tablero Ouija",
  "Dragon's Eye": "Ojo del Dragón",
  "Treasure Chest": "Cofre del Tesoro",
  "Fate arrives hidden under themed foil — scratch it clean to see who was chosen.": "El destino llega oculto bajo una lámina temática: ráscala para ver quién fue elegido.",
  "Shake the ball until the answer floats up through the ink.": "Agita la bola hasta que la respuesta flote a través de la tinta.",
  "Every contender rides the wheel — flick it and let it settle.": "Todos los candidatos giran en la rueda: lánzala y deja que se detenga.",
  "Tap the wand — a burst of fae sparkles unveils the fate.": "Toca la varita: un estallido de destellos feéricos revela el destino.",
  "Jack in and watch the breach log decrypt your target, character by character.": "Conéctate y mira cómo el registro descifra tu objetivo, carácter por carácter.",
  "Crack the 3-digit cipher before the countdown forces a system override.": "Descifra el código de 3 dígitos antes de que la cuenta atrás fuerce el sistema.",
  "Crank the brass gear until the pressure valve blows the fate loose.": "Gira el engranaje de latón hasta que la válvula libere el destino.",
  "Shake the carved mug until it tips — the fate pours out with the drums.": "Agita la taza tallada hasta que se vuelque: el destino se derrama con los tambores.",
  "Rumble the island volcano awake — it erupts and the fate emerges.": "Despierta el volcán de la isla: entra en erupción y emerge el destino.",
  "Three cards face down. The Reaper insists you draw one.": "Tres cartas boca abajo. El Segador insiste en que saques una.",
  "Knock three times — the casket creaks open in soul-light.": "Toca tres veces: el ataúd se abre con luz de almas.",
  "Snuff five candles, one by one, until the spirits speak in the dark.": "Apaga cinco velas, una a una, hasta que los espíritus hablen en la oscuridad.",
  "The planchette drags itself across the board, spelling out where you'll eat.": "La planchette se arrastra por el tablero, deletreando dónde comerás.",
  "Wake the sleeping dragon — its molten eye opens and fixes on your fate.": "Despierta al dragón dormido: su ojo fundido se abre y se fija en tu destino.",
  "Break the iron lock — the hoard bursts open in a fountain of gold.": "Rompe el candado de hierro: el tesoro estalla en una fuente de oro.",
  "New fate witnessed!": "¡Nuevo destino presenciado!",
  "Collection": "Colección",
  "Fate is buried — sweep the leaves away!": "El destino está enterrado: ¡barre las hojas!",
  "The harvest has chosen...": "La cosecha ha elegido...",
  "Coax the blossom open...": "Anima al capullo a abrirse...",
  "Fate blossoms!": "¡El destino florece!",
  "Smash the watermelon!": "¡Rompe la sandía!",
  "A juicy fate splits open!": "¡Un destino jugoso se parte!",
  "Leaf Pile": "Montón de Hojas",
  "Cherry Bloom": "Flor de Cerezo",
  "Watermelon Smash": "Sandía Rota",
  "Fate lies buried under the harvest — sweep the leaves until it shows.": "El destino yace enterrado bajo la cosecha: barre las hojas hasta que aparezca.",
  "Coax the sakura buds until the branch bursts into full blossom.": "Anima los capullos de sakura hasta que la rama estalle en plena floración.",
  "Three good whacks and the melon splits in a juicy spray of seeds.": "Tres buenos golpes y la sandía se parte en un jugoso estallido de semillas.",
  "Duel a friend": "Reta a un amigo",
  "Fate Duel": "Duelo del Destino",
  "Two mortals. One location. Fate favors only one.": "Dos mortales. Un lugar. El destino favorece solo a uno.",
  "Summoning the duel…": "Invocando el duelo…",
  "This duel has vanished into the void.": "Este duelo se ha desvanecido en el vacío.",
  "Deal your own fate": "Reparte tu propio destino",
  "The challenger": "El retador",
  "The challenged": "El retado",
  "Awaiting a rival…": "Esperando a un rival…",
  "You": "Tú",
  "VS": "VS",
  "Fate favors": "El destino favorece a",
  "carries the higher fate-score. The Reaper has spoken.": "lleva la puntuación del destino más alta. La Parca ha hablado.",
  "Your fate is sealed. Waiting for your rival to answer…": "Tu destino está sellado. Esperando a que tu rival responda…",
  "Share the duel link": "Comparte el enlace del duelo",
  "has locked in fate's pick and challenges you. Let fate deal yours for the same grounds.": "ha sellado la elección del destino y te reta. Deja que el destino reparta el tuyo en el mismo territorio.",
  "Fate is dealing…": "El destino está repartiendo…",
  "Let fate deal mine": "Que el destino reparta el mío",
  "Fate picks from the challenger's location — no peeking, no rerolls.": "El destino elige desde la ubicación del retador — sin mirar, sin repetir.",
  "Fate found nothing near the duel grounds — try again in a moment": "El destino no encontró nada cerca del terreno del duelo — inténtalo de nuevo en un momento",
  "This duel was already answered": "Este duelo ya fue respondido",
  "Fate stumbled — try again": "El destino tropezó — inténtalo de nuevo",
  "Duel link copied — send it to your rival!": "¡Enlace del duelo copiado — envíaselo a tu rival!",
  "I challenge you to a Fate Duel! Fate dealt me": "¡Te reto a un Duelo del Destino! El destino me repartió",
  "let it deal yours and see who fate favors:": "deja que reparta el tuyo y ve a quién favorece el destino:",
  "Duel created! Send the link, then watch the arena.": "¡Duelo creado! Envía el enlace y observa la arena.",
  "View duel": "Ver duelo",
  "Couldn't forge the duel — try again": "No se pudo forjar el duelo — inténtalo de nuevo",
  "Conquest Map": "Mapa de Conquista",
  "— every spot fate ever sent you, pinned": "— cada lugar al que el destino te envió, marcado",
  "Back to the journal": "Volver al diario",
  "spots conquered — every pin is a place fate sent you.": "lugares conquistados — cada pin es un lugar al que el destino te envió.",
  "No pins yet — from now on, every fate you land drops a pin here. Go let fate deal!": "Aún no hay pines — desde ahora, cada destino que caiga deja un pin aquí. ¡Ve y deja que el destino reparta!",
  "Your past fates were recorded before map pins existed — new deals will start pinning from here on out.": "Tus destinos pasados se registraron antes de que existieran los pines — los nuevos repartos empezarán a marcarse desde ahora.",
  "Duel Record": "Historial de Duelos",
  "wins in a row — fate favors you.": "victorias seguidas — el destino te favorece.",
  "losses in a row — fate demands tribute.": "derrotas seguidas — el destino exige tributo.",
  "W": "V",
  "L": "D",
  "vs": "vs",
  "Enjoy the view — tap the eye to bring everything back": "Disfruta la vista — toca el ojo para traerlo todo de vuelta",
  "Run it back": "Otra ronda",
  "Demand a rematch": "Exige la revancha",
  "Dealing a new hand…": "Repartiendo una nueva mano…",
  "Rematch! Fate dealt me a new hand — your move:": "¡Revancha! El destino me repartió una nueva mano — tu turno:",
  "Share the verdict": "Comparte el veredicto",
  "Building card…": "Creando la tarjeta…",
  "Verdict card saved!": "¡Tarjeta del veredicto guardada!",
  "Fate has spoken — think you can beat my pick? Duel me on Fork·Fate:": "El destino ha hablado — ¿crees que puedes superar mi elección? Rétame en Fork·Fate:",
};

const DICTS = { es: ES };

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (s) => s });

function detectInitial() {
  try {
    const saved = localStorage.getItem("ff_lang");
    if (saved === "en" || saved === "es") return saved;
    const nav = (navigator.language || navigator.userLanguage || "").toLowerCase();
    if (nav.startsWith("es")) return "es";
  } catch (e) { /* ignore */ }
  return "en";
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(detectInitial);

  useEffect(() => {
    try { localStorage.setItem("ff_lang", lang); document.documentElement.setAttribute("lang", lang); } catch (e) { /* ignore */ }
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l === "es" ? "es" : "en"), []);

  const t = useCallback((s) => {
    if (lang === "en" || s == null) return s;
    const d = DICTS[lang];
    return (d && d[s]) || s;
  }, [lang]);

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
